import { css } from "styled-components"

export const deprecatedGradient = css`
  background: linear-gradient(
    90deg,
    #e8e3e3 0%,
    #9f9f9f 11.02%,
    #b3f9a7 21.55%,
    #c3c2ff 32.57%,
    #e4e4e4 45.02%,
    #b9b6b8 55.31%,
    #f3ffdd 64.17%,
    #e5e5e5 73.27%,
    #dfcbff 88.6%,
    #b5a3dc 100%
  );
  background-color: ${({ theme }) => theme.colors.gradient.purple};
`

export const deprecatedGradientAnimated = css`
  ${deprecatedGradient}

  background-size: 400% 400%;
  animation: movingGradient 15s linear infinite;
  @keyframes movingGradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`
